import { atom } from 'recoil';
import { additionalNameInsuredSelector } from '../selectors/additionalNameInsuredSelector';
import type { AdditionalNameInsuredDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/policycommon/additionalnameinsured';

export const additionalNameInsuredAtom = atom<AdditionalNameInsuredDTO[]>({
    key: 'additionalNameInsured',
    default: additionalNameInsuredSelector
});
